import { react2angular } from 'react2angular';
import { AlarmEventViewModal } from './AlarmEventViewModal';

angular.module('webtip.module')
  .component('alarmEventViewModal', react2angular(AlarmEventViewModal, ['alarmEvent', 'onClose'], [
    'alarmEventService',
    'alarmRuleService',
    'analysisService',
    'eventsExportService',
    'alarmNotificationService',
    'formatTimestampFilter',
    '$translate',
  ]))
  .component('alarmEventViewDialog', {
    bindings: { resolve: '<', dismiss: '&' },
    template: '<alarm-event-view-modal alarm-event="$ctrl.resolve.alarmEvent" on-close="$ctrl.dismiss"></alarm-event-view-modal>',
  });